import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { selectEmailAccounts } from '@mm/state/selectors/emailAccountsSelectors';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { Step } from '../AutomationEdit/Step/Step';
import automationStyles from '../automationStyles.module.css';
import { AutomationChannelButton } from '../components/AutomationChannelButton';
import { AutomationHeader } from '../components/AutomationHeader/AutomationHeader';
import { useAutomations } from '../use-automations';

export const AutomationNew: FunctionComponent = () => {
  const { createAutomation } = useAutomations();
  const activeFacebookPage = useSelector(activeFacebookPageSelector);
  const modalActions = useModalActions();
  const isEmailConnected =
    !!useSelector(selectEmailAccounts)?.length ||
    !!activeFacebookPage?.emailActivated;
  const onChooseEmail = () => {
    // TODO: ensure email account before proceeding
    if (isEmailConnected) {
      createAutomation('email_sold_automation', undefined);
    } else {
      modalActions.openActivateEmailAccountModal();
    }
  };
  const onChooseSMS = () => {
    createAutomation('empty_automation', undefined);
  };

  const isSmsDisabled = useSelector(
    combinedFeatureFlagsSelector,
  ).twillio_campaigns_disabled;

  return (
    <div className={automationStyles.container}>
      <AutomationHeader state={{ busy: 'new', error: '' }} />
      <div className={automationStyles.editor}>
        <Step
          number={1}
          lineStyle="none"
          circleStyle="shadow"
          numberStyle="bold"
        >
          <div className={automationStyles.stepTitle}>
            Do you want to create an email or SMS automation?
          </div>
          <div className={automationStyles.stepSubtitle}>
            Choose which accounts you will contact your leads with
          </div>
          <div className={automationStyles.channels}>
            <AutomationChannelButton onClick={onChooseEmail} channel="email" />
            <AutomationChannelButton
              onClick={onChooseSMS}
              channel="sms"
              disabled={isSmsDisabled}
            />
          </div>
        </Step>
      </div>
    </div>
  );
};
